import { usePlaybooksQuery } from './usePlaybooksQuery';
import { usePlaybooksSearch } from './usePlaybooksSearch';
import { usePlaybooksTableColumns } from './usePlaybooksTableColumns';

export const usePlaybooks = (filters: Record<string, string> = {}) => {
    const { data: items = [], isLoading: loading } = usePlaybooksQuery(filters);
    const { keyword } = usePlaybooksSearch();
    const { columns } = usePlaybooksTableColumns();

    // Filter items based on keyword (client-side filtering)
    const visibleItems = items.filter(item =>
        !keyword ||
        item.name?.toLowerCase().includes(keyword.toLowerCase()) ||
        item.description?.toLowerCase().includes(keyword.toLowerCase())
    );

    return {
        items,
        visibleItems,
        loading,
        columns,
    };
};
